import {forwardRef} from 'react';

import {BotSuggestion} from './bot_suggestion';
import {ChannelSuggestion} from './channel_suggestion';
import {SuggestionProps, SuggestionType} from './types';
import {UserSuggestion} from './user_suggestion';

export const Suggestion = forwardRef<HTMLDivElement, SuggestionProps>((props, ref) => {
    switch (props.type) {
    case SuggestionType.User:
        return <UserSuggestion ref={ref} {...props} />;
    case SuggestionType.Bot:
        return <BotSuggestion ref={ref} {...props} />;
    case SuggestionType.Channel:
        return <ChannelSuggestion ref={ref} {...props} />;
    default:
        return null;
    }
});
